import React, {
   Fragment,
   useCallback,
   useContext,
   useEffect,
   useMemo,
   useRef,
   useState,
} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { CartContext } from "../../Context/CartContext.js";
import { useNavigate } from "react-router-dom";

import style from "./priceOffers.module.css";
import CustomTitle from "../CustomTitle/CustomTitle.jsx";
import debounce from "lodash.debounce";

export default function PriceOffers() {
   const { getLoggedCart } = useContext(CartContext);
   const [testId, setTestId] = useState("");
   const [show, setShow] = useState(false);
   const [listTest, setListTest] = useState([]);
   const [listTestName, setListTestName] = useState([]);
   const [search, setSearch] = useState([]);
   const [priceOffer, setPriceOffer] = useState([]);
   const [loading, setLoading] = useState(false); // ✅ loading state

   const navigate = useNavigate();
   const inputSearch = useRef(null);

   const token = localStorage.getItem("token");
   const header = useMemo(
      () => ({
         token: `${process.env.REACT_APP_BEARER_TOKEN} ${token}`,
      }),
      [token]
   );

   //& Search Test By Test Name :
   function searchInput(e) {
      const value = e.target.value;
      if (value === "") {
         setSearch([]);
         return;
      }
      if (value.length >= 3) {
         debouncedSearch(value.toLowerCase());
      }
   }

   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      try {
         setLoading(true); // start loading
         let response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`
         );
         if (response?.data.message === "success") {
            setSearch(response?.data.tests);
         }
      } catch (error) {
         console.log(error.response?.data.message);
      } finally {
         setLoading(false); // stop loading
      }
   }

   //& Active debounce :
   const debouncedSearch = useMemo(() => debounce(getSearchData, 300), []);

   const getAllTestPrice = useCallback(async () => {
      await axios
         .post(
            `${process.env.REACT_APP_BASE_URL}/api/v1/offers/prices`,
            { listIdTest: listTest },
            { headers: header }
         )
         .then(({ data }) => {
            if (data.message === "success") {
               setPriceOffer(data.priceList);
            }
         })
         .catch((error) => {
            inputSearch.current.value = "";
            if (error.response?.data?.message === "Prices is Empty") {
               setPriceOffer([]);
            }
         });
   }, [listTest, header, setPriceOffer]);

   function addTestToList(id, name) {
      if (listTest.find((ele) => ele === id)) {
         return;
      }
      setListTest([...listTest, id]);
      setListTestName([...listTestName, { id, name }]);
      setSearch([]);
      inputSearch.current.value = "";
   }

   const addTestId = (ele) => {
      let listIdTest = [];
      let company_id = "";
      ele.arr.forEach(async (item) => {
         listIdTest.push(item.test);
         company_id = item.company;
      });
      addAllTestToCart(listIdTest, company_id);
   };

   async function addAllTestToCart(listIdTest, company_id) {
      await axios
         .post(
            `${process.env.REACT_APP_BASE_URL}/api/v1/cart/addAllTest`,
            { listIdTest, company_id },
            { headers: header }
         )
         .then(({ data }) => {
            if (data.message === "success") {
               getLoggedCart();
               navigate("/cart");
            }
         })
         .catch((error) => {
            toast.warn(error.response.data.message, {
               position: "top-right",
            });
         });
   }

   const deleteTest = (test) => {
      setListTest((prevTest) => prevTest.filter((ele) => ele !== test.id));
      setListTestName((prevTest) =>
         prevTest.filter((ele) => ele.name !== test.name)
      );
      if (listTest.length || listTestName.length) {
         setPriceOffer([]);
      }
   };

   useEffect(() => {
      if (!listTest.length) return;
      getAllTestPrice();
   }, [listTest.length, getAllTestPrice]);

   useEffect(() => {
      return () => {
         debouncedSearch.cancel();
      };
   }, [debouncedSearch]);

   return (
      <Fragment>
         <CustomTitle title="عروض الاسعار" />
         <div className={`${style.priceOffer_container} container`}>
            <div className="p-2 m-auto">
               <h1 className="main-header my-4">إضافة خدمات جديدة </h1>
               <div className="row">
                  <div>
                     <div className="col-md-8 offset-md-2">
                        <form>
                           <div className="position-relative">
                              {/* Left search icon */}
                              <i
                                 className={`${style.icon_search} fa-solid fa-microscope position-absolute top-50 start-0 translate-middle-y ms-3 text-muted`}
                              ></i>

                              {/* Input */}
                              <input
                                 ref={inputSearch}
                                 type="search"
                                 onChange={(e) => searchInput(e)}
                                 className="form-control py-4 ps-5 pe-5 shadow-sm rounded-pill"
                                 id="test_search"
                                 placeholder="أضافة خدمات جديدة"
                                 name="search"
                                 disabled={loading}
                                 style={{
                                    paddingRight: loading ? "3rem" : "2.5rem" // Extra space when loading
                                 }}
                              />

                              {/* Tiny loading spinner (right) */}
                              {loading && (
                                 <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                    <div
                                       className={`${style.loading_search}`}
                                       role="status"

                                    >
                                       <span className="visually-hidden">جاري البحث...</span>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </form>

                        {/* Search results */}
                        {search.length > 0 && (
                           <div
                              className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-3 overflow-auto shadow-sm`}
                              style={{ maxHeight: "200px" }}
                           >
                              {search.map((ele) => (
                                 <p
                                    key={ele._id}
                                    onClick={() => addTestToList(ele._id, ele.name)}
                                    className="bg-white border rounded-2 p-2 fw-bold m-0 my-1 main-color cursor-pointer"
                                    style={{ transition: "0.2s" }}
                                 >
                                    {ele.name}
                                 </p>
                              ))}
                           </div>
                        )}
                     </div>
                  </div>
               </div>
            </div>

            {/* Selected tests */}
            {!show && (
               <div className="container">
                  {listTestName.map((ele) => (
                     <div key={ele.id} className="bg-body-secondary rounded-3">
                        <div className="d-flex justify-content-between px-2 my-1 bg-body-tertiary rounded-3">
                           <i
                              onClick={() => deleteTest(ele)}
                              className="fa-solid fa-trash text-danger btn"
                           ></i>
                           <p className="text-center p-0 m-0">{ele.name}</p>
                        </div>
                     </div>
                  ))}
               </div>
            )}

            {/* Price offers */}
            {show && (
               <div className="container">
                  <div className="row">
                     {priceOffer.map((ele, index) => (
                        <label
                           key={index}
                           htmlFor={`offer_${index}`}
                           className="btn w-100 d-block"
                           style={{ cursor: "pointer" }}
                        >
                           <div className="p-1 py-2 bg-light rounded-2 my-1 row align-items-center border border-1">
                              <div className="col-5 p-0">
                                 <div>
                                    <img
                                       src={ele.companyImage}
                                       className={style.imageOffer}
                                       alt="logo"
                                    />
                                    <p className="d-inline-block m-0 p-0">
                                       {ele.companyName}
                                    </p>
                                 </div>
                              </div>
                              <div className="col-6 p-0">
                                 <p className="text-center fw-bold m-0">
                                    <span className="text-danger text-decoration-line-through">
                                       {Math.round(ele.total.totalPrice)}
                                    </span>
                                    <span className="main-color d-inline-block mx-2">
                                       بدلا من
                                    </span>
                                    <span className="main-color">
                                       {Math.round(ele.total.totalPriceAfterDiscount)}
                                    </span>
                                 </p>
                              </div>
                              <div className="col-1 p-0 text-center">
                                 <input
                                    type="radio"
                                    id={`offer_${index}`}
                                    onChange={() => setTestId(ele)}
                                    name="selected_offer"
                                    checked={
                                       JSON.stringify(testId) === JSON.stringify(ele)
                                    }
                                    style={{ cursor: "pointer" }}
                                 />
                              </div>
                           </div>

                           {JSON.stringify(testId) === JSON.stringify(ele) && (
                              <div className="text-center my-2">
                                 <button
                                    type="button"
                                    className="btn bg-main w-100"
                                    onClick={() => addTestId(testId)}
                                 >
                                    تأكيد
                                 </button>
                              </div>
                           )}
                        </label>
                     ))}
                  </div>
               </div>
            )}

            {/* Action buttons */}
            <div className="container text-center">
               <button
                  className="btn btn-new-color btn-sm m-2"
                  onClick={() => {
                     setShow(false);
                  }}
               >
                  إضافة خدمات أخرى
               </button>
            </div>
            <div className="container text-center">
               <button
                  className="btn btn-new-color m-2 btn-sm w-50"
                  onClick={() => {
                     setShow(true);
                  }}
               >
                  أختيار مقدم الخدمة
               </button>
            </div>
         </div>
      </Fragment>
   );
}
